(() => {
  const PROMO_TEXT = '30% off when you buy 3 or more';
  const CART_ROOTS = '.cart-drawer, .cart-page, [data-dos-cart]';
  const SUBSCRIPTION_STYLE_ID = 'dos-subscription-style';

  const policyContent = {
    shipping: {
      eyebrow: 'Shipping info',
      title: 'Free shipping at $50+',
      lead: 'When qualifying merchandise in your order reaches $50, standard free shipping is available where the order and destination qualify.',
      cards: [
        ['Build your basket', 'Mix and match qualifying finds from around the store. You do not need one $50 item.'],
        ['Reach $50+', 'Once your qualifying merchandise reaches $50, eligible standard shipping is shown at checkout.']
      ],
      fine: 'Some oversized, special-handling, remote-destination, or otherwise excluded orders may not qualify. Final shipping options and timing are shown at checkout.'
    },
    returns: {
      eyebrow: '30-day returns',
      title: 'Changed your mind? Send it back.',
      lead: 'Most eligible items can be returned within 30 days of delivery. We want you to feel comfortable trying Dawterson without turning the policy into fine-print gymnastics.',
      cards: [
        ['Keep it return-ready', 'When applicable, send the item back with its included parts, accessories, and packaging in reasonable return condition.'],
        ['We keep it fair', 'Heavy wear, alterations, smoke or burn damage, stains, missing parts, or other customer-caused damage may make an item ineligible.']
      ],
      fine: 'Hygiene-sensitive, final-sale, oversized, or special-handling items may have clearly stated exceptions. Return-shipping terms, when applicable, are confirmed during the return process.'
    }
  };

  function updateCartPromoText(root = document) {
    root.querySelectorAll(CART_ROOTS).forEach((cartRoot) => {
      const walker = document.createTreeWalker(cartRoot, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach((node) => {
        if (!node.nodeValue || node.nodeValue.trim().toLowerCase() !== '3 pack') return;
        const parent = node.parentElement;
        if (!parent) return;
        node.nodeValue = PROMO_TEXT;
        parent.classList.add('dos-buy3-promo');
      });
    });
  }

  function addSubscriptionStyles() {
    if (document.getElementById(SUBSCRIPTION_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = SUBSCRIPTION_STYLE_ID;
    style.textContent = `
      .dos-subscribe-save{margin:4px 0 12px;padding:14px 16px;border:1px solid rgba(168,121,73,.25);border-radius:16px;background:linear-gradient(145deg,#fffaf3,#f6efe5);box-shadow:0 8px 22px rgba(45,33,27,.05);color:#2d211b}
      .dos-subscribe-save__title{display:flex;align-items:center;gap:8px;color:#6f2634;font-family:Georgia,'Times New Roman',serif;font-size:1.12rem;font-weight:700;line-height:1.25}
      .dos-subscribe-save__badge{display:inline-flex;align-items:center;padding:3px 8px;border-radius:999px;background:#6f2634;color:#fffaf3;font-family:var(--font-body--family);font-size:.72rem;font-weight:800;letter-spacing:.02em}
      .dos-subscribe-save__meta{margin-top:5px;color:#725747;font-size:.86rem;line-height:1.4}
      .product-information:has([name='selling_plan']) [name='selling_plan']{accent-color:#6f2634}
      .product-information:has([name='selling_plan']) label{opacity:1}
    `;
    document.head.appendChild(style);
  }

  function decorateSubscriptionOffer(root = document) {
    const productInfo = root.querySelector?.('.product-information') || document.querySelector('.product-information');
    if (!productInfo) return;
    const eyebrow = productInfo.querySelector('.dos-product-eyebrow');
    if (!eyebrow || eyebrow.textContent.trim().toLowerCase() !== 'health') return;

    const sellingPlanControl = productInfo.querySelector("[name='selling_plan']");
    if (!sellingPlanControl) return;
    addSubscriptionStyles();
    if (productInfo.querySelector('.dos-subscribe-save')) return;

    const offer = document.createElement('div');
    offer.className = 'dos-subscribe-save';
    offer.setAttribute('data-dos-subscription-offer', '17');
    offer.innerHTML = '<div class="dos-subscribe-save__title">Subscribe &amp; Save <span class="dos-subscribe-save__badge">17% OFF</span></div><div class="dos-subscribe-save__meta">Delivered monthly. Keep your wellness ritual stocked and save on every recurring order.</div>';

    const appContainer = sellingPlanControl.closest('.shopify-block, [class*="subscription"], [class*="selling-plan"], fieldset, form');
    if (appContainer && appContainer.parentNode) appContainer.parentNode.insertBefore(offer, appContainer);
    else sellingPlanControl.parentNode?.insertBefore(offer, sellingPlanControl);
  }

  function ensurePolicyDialog() {
    let dialog = document.querySelector('.dos-policy-dialog');
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'dos-policy-dialog';
    dialog.setAttribute('aria-labelledby', 'dos-policy-title');
    dialog.innerHTML = `
      <div class="dos-policy-dialog__scroll">
        <button class="dos-policy-panel__close" type="button" aria-label="Close policy information">×</button>
        <div class="dos-policy-panel__eyebrow"></div>
        <h2 class="dos-policy-panel__title" id="dos-policy-title"></h2>
        <p class="dos-policy-panel__lead"></p>
        <div class="dos-policy-panel__cards"></div>
        <p class="dos-policy-panel__fine"></p>
      </div>`;
    document.body.appendChild(dialog);

    const close = () => {
      if (dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('dos-policy-open');
      const trigger = document.querySelector('[data-dos-policy][aria-expanded="true"]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({ preventScroll: true });
      }
    };

    dialog.querySelector('.dos-policy-panel__close').addEventListener('click', close);
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('dos-policy-open');
    });
    return dialog;
  }

  function openPolicy(type, trigger) {
    const content = policyContent[type];
    if (!content) return;
    const dialog = ensurePolicyDialog();
    dialog.querySelector('.dos-policy-panel__eyebrow').textContent = content.eyebrow;
    dialog.querySelector('.dos-policy-panel__title').textContent = content.title;
    dialog.querySelector('.dos-policy-panel__lead').textContent = content.lead;
    dialog.querySelector('.dos-policy-panel__fine').textContent = content.fine;
    dialog.querySelector('.dos-policy-panel__cards').innerHTML = content.cards.map(([title, body]) => `<div class="dos-policy-panel__card"><strong>${title}</strong><span>${body}</span></div>`).join('');
    document.querySelectorAll('[data-dos-policy]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    trigger?.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('dos-policy-open');

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
      dialog.style.position = 'fixed';
      dialog.style.inset = '0';
      dialog.style.zIndex = '2147483647';
    }

    requestAnimationFrame(() => {
      dialog.querySelector('.dos-policy-dialog__scroll')?.scrollTo(0, 0);
      dialog.querySelector('.dos-policy-panel__close')?.focus({ preventScroll: true });
    });
  }

  function wirePolicyTriggers(root = document) {
    root.querySelectorAll?.('[data-dos-policy]').forEach((button) => {
      if (button.dataset.dosPolicyWired === 'true') return;
      button.dataset.dosPolicyWired = 'true';
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openPolicy(button.dataset.dosPolicy, button);
      });
    });
  }

  let scheduled = false;
  const scheduleUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      updateCartPromoText();
      decorateSubscriptionOffer();
      wirePolicyTriggers();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
  else scheduleUpdate();

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
